import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AEM_ROUTE_ERROR } from './const';
import { AemService } from '../lib/apis/AemService';

export const useAemRoute = (props) => {
    const { pathnameCustom } = props;

    const { pathname } = useLocation();
    const [pageData, setPageData] = useState(undefined);
    const [isLoading, setLoading] = useState(true);
    const [routeError, setRouteError] = useState(undefined);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            setPageData(null);
            try {
                //single component-level request
                if (pathnameCustom) {
                    setPageData(
                        await AemService().getRoutePage(pathnameCustom)
                    );
                }
                //full page-level request
                else {
                    setPageData(await AemService().getRoutePage(pathname));
                }
            } catch (e) {
                setPageData(null);
                setRouteError(AEM_ROUTE_ERROR.INTERNAL_ERROR);
                return;
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, [pathname]);

    return { pageData, routeError, isLoading, pathname };
};
